const navigate = {
  methods: {
    navigateNewTab (path){
      let route = this.$router.resolve({ path: path })
      window.open(route.href, '_blank')
    }
  }
}

export default navigate